import React, { useMemo } from "react";
import { motion } from "framer-motion";

// Sprint 8.D — Milestone-Avatar-Tag im Cockpit-Header.
// Mapping: 7 / 30 / 90 / 180 / 365 Tage → Badge mit Label + Farbe.

const MILESTONES = [
  { days: 365, label: "1-Jahr-Flexpfad-Explorer", color: "#7C3AED", glyph: "🏆" },
  { days: 180, label: "Halbjahres-Flexpfad-Explorer", color: "#DC2626", glyph: "🥇" },
  { days: 90, label: "90-Tage-Flexpfad-Explorer", color: "#EA580C", glyph: "🥈" },
  { days: 30, label: "30-Tage-Flexpfad-Explorer", color: "#0EA5E9", glyph: "🥉" },
  { days: 7, label: "1-Woche-Flexpfad-Explorer", color: "#10B981", glyph: "🌱" },
];

export default function AvatarTag({ daysActive }) {
  const milestone = useMemo(() => {
    const d = Number(daysActive) || 0;
    return MILESTONES.find((m) => d >= m.days) || null;
  }, [daysActive]);

  if (!milestone) return null;

  return (
    <motion.span
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, type: "spring", stiffness: 220 }}
      data-testid="cockpit-avatar-tag"
      title={`Du bist seit ${daysActive} Tagen dabei.`}
      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold text-white shadow-sm whitespace-nowrap"
      style={{ backgroundColor: milestone.color }}
    >
      <span aria-hidden="true">{milestone.glyph}</span>
      <span>{milestone.label}</span>
    </motion.span>
  );
}
